export default __webpack_public_path__ + "static/media/normal1.72e94cfd.jpg";